import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useVideoCVApi() {
  const callApi = useApiCall();

  const getJobseekersWithVideo = (params = {}, onSuccess: Function, onError: Function) => {
    const payload = {
      params,
    };
    callApi(SAGA_ACTIONS.VIDEO_CV.GET_JOBSEEKERS_WITH_VIDEO, payload, onSuccess, onError, true);
  };

  return {
    callGetJobseekersWithVideo: getJobseekersWithVideo,
  };
}
